import { render, staticRenderFns } from "./cart-dropdown.app.vue?vue&type=template&id=64454176&"
import script from "./cart-dropdown.app.vue?vue&type=script&lang=js&"
export * from "./cart-dropdown.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports